module.exports = __webpack_public_path__ + "static/full06-9240002d95f68f3a00e57a7f4eaf90bb.png";